<template>
  <div>
    <div class="table__filter">
      <p4a-button :showIcon="true"
                  style="margin-left: 5px; margin-top: 12px;"
                  :onlyIconVisible="false"
                  :size="'small'"
                  :text="$i18n.t('DocumentGrid.ApplyFilter')"
                  :borderColor="'#00bbd5'"
                  :hoverColor="'#00bbd5'"
                  :icon="'filter'"
                  @click="applyFilter">
      </p4a-button>
      <p4a-button :showIcon="true"
                  style="margin-left: 3px; margin-top: 12px;"
                  :onlyIconVisible="false"
                  :size="'small'"
                  :text="$i18n.t('DocumentGrid.RemoveFilters')"
                  :borderColor="removeFilterColor"
                  :hoverColor="removeFilterColor"
                  :icon="'filter-delete'"
                  :class="{'control-disabled': !hasCriteria}"
                  @click="filterDelete"
                  >
      </p4a-button>
      <p4a-button :showIcon="true"
                  style="margin-left: 25px; margin-top: 12px;"
                  :onlyIconVisible="false"
                  :size="'small'"
                  :text="$i18n.t('DocumentGrid.SearchAllFolders')"
                  :borderColor="'#00bbd5'"
                  :hoverColor="'#00bbd5'"
                  :icon="'search'"
                  @click="searchInAllFolders">
      </p4a-button>
      <pagination-control
        :style="{ 'float': 'right'}"
        :currentPage="componentCurrentPage"
        :totalResult="componentTotalResult"
        :itemsPerPage="itemsPerPage"
        @setItemsPerPage="setItemsPerPage"
        @pageChanged="pageChanged"
      ></pagination-control>
    </div>
    <criteria-bar v-show="hasCriteria" :class="{'bb-1': hasCriteria}"
      style="top: 50px; position: absolute; overflow-x: auto; overflow-y: hidden; width:100%;"
      :criteria-data="criteriaData"
    ></criteria-bar>
    <div class="table" ref="table"
      :style="tableStyle"
      :class="{'dropzone-hover': dropzoneActive}"
      @dragover="dragover"
      @dragleave="dragleave"
      @drop="drop">
      <table>
        <thead class="table__head" :class="{'bt-1': hasCriteria}">
        <tr>
          <th class="table__select sticky" id="checkbox_header_cell">
            <p4a-checkbox
              :disabled="false"
              :selected="false"
              :textHidden="true"
              :checked="hasAllSelected"
              @change="selectAll">
            </p4a-checkbox>
          </th>
          <th class="table__image sticky" style="width: 40px; max-width: 40px; min-width: 40px;"></th>
          <th class="drag" v-for="head in headers" :key="head.Id">
              <header-cell
                :item="head"
                :property="head.Caption"
                :cell-width="head.width"
                :folderId="folderId"
                :resultFromSearch="resultFromSearch"
                @filterOptionsRequested="filterOptionsRequested"
                @optionsSelected="filterOptionsSelected"
              />
          </th>
        </tr>
        </thead>
        <tbody class="table__body">
        <tr :class="row.IsActive ? 'selected' : ''"
          class="table_row"
          v-for="(row, index) in body"
          :key="getDocumentKey(row)"
          :ref="`tr-${row.Id}-${index}`"
          :index="index"
          :id="row.Id"
          :folderId="row.FolderId"
          :verid="row.LastDocumentVersionId"
          :filename="row.LastDocumentVersionLocalFilename"
          :dontOpen="row.Properties.DontOpen"
          v-click-outside="closeContextMenu"
          @contextmenu="showContextMenu($event, row, index)"
          @click="rowClick(row, index)"
          @dblclick="rowDobleClick($event, row, index)">
          <td id="checkbox_cell" @click.shift="shiftCheck(row, index)">
            <p4a-checkbox
              :disabled="false"
              :textHidden="true"
              :checked="row.IsSelected"
              @change="check(row.Id)"
            >
            </p4a-checkbox>
          </td>
          <td class="table__image">
            <img :src="require('../../assets/img/grid/' + row.Properties.FileType)" :alt="row.Properties.FileType"/>
          </td>
          <td v-for="header in headers" :key="header.Id + '-column'">
            <template v-if="header.Caption === ''">
              <img :src="require('../../assets/img/doc_icons/' + getColumnImage(row.Properties[header.FieldName]))" :alt="header.FieldName"/>
            </template>
            <template v-else>
              <span class="text_cell" v-html="formatCellValue(row.Properties, header)"></span>
            </template>
          </td>
        </tr>
        </tbody>
      </table>
      <input type="file" hidden multiple ref="file" @change="filesDroped" accept=".pdf,.jpg,.jpeg,.png" />
    </div>
  </div>
</template>

<script>
import HeaderCell from './Cells/HeaderCell'
import PaginationControl from './paginationControl'
import SvgButton from '../ButtonTemplates/SvgButton.vue'
import CriteriaBar from './Criteria/CriteriaBar'
import mixins from 'mixins'

export default {
  name: 'GridDocument',
  components: {
    'header-cell': HeaderCell,
    'pagination-control': PaginationControl,
    'svg-button': SvgButton,
    'criteria-bar': CriteriaBar
  },
  mixins: [mixins],
  props: {
    folderId: {
      type: Number,
      default: -1
    },
    headers: {
      default: function () {
        return []
      },
      type: Array
    },
    body: {
      default: function () {
        return []
      },
      type: Array
    },
    currentPage: {
      default: 1,
      type: Number
    },
    totalResult: {
      default: 0,
      type: Number
    },
    itemsPerPages: {
      default: 50,
      type: Number
    },
    resultFromSearch: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      compact: localStorage.getItem('compact') === 'false',
      sortTable: true,
      allSelected: false,
      componentCurrentPage: this.currentPage,
      itemsPerPage: this.itemsPerPages,
      criteriaData: {
        staticCriteria: []
      },
      activeRow: {},
      dropzoneActive: false,
      dropTimeOut: null,
      dropedFilesList: [],
      sortOrder: {
        fieldName: '',
        order: 'asc'
      }
    }
  },
  created () {
    this.criteriaData.staticCriteria = this.$store.getters.getCriteriaList
    this.sortOrder = this.$store.getters.getSortOrder
    this.$eventBus.$on('orderByEvent', () => {
      this.orderBy()
    })
    this.$eventBus.$on('folderChanged', (item) => {
      if (item != null) {
        this.rowClick(item, item.index, false)
      }
    })
  },
  updated () {
    this.criteriaData.staticCriteria = this.$store.getters.getCriteriaList
    this.sortOrder = this.$store.getters.getSortOrder
  },
  computed: {
    componentTotalResult () {
      return this.totalResult
    },
    hasCriteria () {
      return this.$store.getters.getAppliedCriteria.length > 0
    },
    removeFilterColor () {
      return this.hasCriteria ? 'orange' : ''
    },
    tableStyle () {
      let top = '0px'
      if (!this.resultFromSearch) {
        top = this.hasCriteria ? '90px' : '50px'
      }
      return {
        'top': top,
        'position': 'absolute',
        'bottom': '0'
      }
    },
    HideDownloadAlert () {
      return this.$store.getters.getDocstreamSettings.HideDownloadAlert
    },
    hasAllSelected () {
      let self = this
      self.allSelected = self.body.every(x => x.IsSelected === true)
      return self.allSelected
    }
  },
  watch: {
    currentPage () {
      this.componentCurrentPage = this.currentPage
    }
  },
  methods: {
    filterDelete () {
      if (this.hasCriteria) {
        this.$store.commit('resetCriteriaList')
        this.$eventBus.$emit('resetCriteriaList')
        this.criteriaData.staticCriteria = this.$store.getters.getCriteriaList
        this.sortOrder = this.$store.getters.getSortOrder
        this.applyFilter()
      }
    },
    applyFilter () {
      let filterList = this.$store.getters.getCriteriaList
      let sortOrder = this.$store.getters.getSortOrder
      this.$emit('applyFilter', {
        'Filters': filterList,
        'Sort': sortOrder
      })
    },
    orderBy () {
      let filterList = this.$store.getters.getAppliedCriteria
      let sortOrder = this.$store.getters.getSortOrder
      this.$emit('orderBy', {
        'Filters': filterList,
        'Sort': sortOrder
      })
    },
    searchInAllFolders () {
      this.reloadIframe('searchInAllDocuments')
    },
    formatCellValue (properties, header) { // row.Properties[header.FieldName], header.Caption
      let value = properties[header.FieldName]
      let txt = document.createElement('textarea')
      txt.innerHTML = value

      let itemslookup = txt.value.split(this.lookupFieldSeparator(header.ValueType))
      if (itemslookup.length > 1) {
        return this.setLookupFields(itemslookup)
      }
      if (header.FieldName === 'ProcedureDaysToGo') {
        if (value != null && value < 0) {
          return `<span style='color: red'>${value}</span>`
        }
      }

      if (properties['Marked'] === 'MarkedIcon') {
        let res = value !== null ? value : ''
        return `<span style='color: blue'>${this.sanitizerHTML(res)}</span>`
      }

      if (properties['ExpectedIsOverdue'] === true) {
        let res = value !== null ? value : ''
        return `<span style='color: red'>${res}</span>`
      }

      return this.sanitizerHTML(value)
    },
    setLookupFields (itemsMultiple) {
      let value = ''
      let resultMultiple = itemsMultiple.length - 1 > 0 ? ' + ' + (itemsMultiple.length - 1) + ' more' : ''
      itemsMultiple.forEach(item => {
        value += item.toString().trim() + '\n'
      })
      return itemsMultiple[0] + `<span style='color: blue' title='${value}'>${resultMultiple}</span>`
    },
    lookupFieldSeparator (ValueType) {
      if (ValueType === 'vt_lookup_hierarchy') return '|'
      if (ValueType === 'vt_lookup_multiple') return '-'
    },
    setItemsPerPage (value) {
      this.itemsPerPage = value
      localStorage.setItem('ds_items_per_page', value)
      this.$emit('pageChanged', { 'page': 1, 'itemsPerPage': value })
    },
    rowClick (row, index, emitEvent = true) {
      this.body.forEach(element => {
        if (this.getDocumentKey(element) === this.getDocumentKey(row)) {
          element.IsActive = true
        } else {
          element.IsActive = false
        }
      })
      this.activeRow = {
        'id': row.Id,
        'index': index
      }
      let rowDOM = this.$refs[`tr-${row.Id}-${index}`]
      if (rowDOM && rowDOM.length > 0) {
        window.selRow = rowDOM[0]
      }
      if (emitEvent) {
        this.$emit('rowSelected', this.getDocumentKey(row))
      }

      this.closeContextMenu()
    },
    rowDobleClick (e, row, index) {
      if (this.HideDownloadAlert || row.Properties.HasConceptOnCurrentComputer === true) {
        let source = this.$refs[`tr-${row.Id}-${index}`]
        if (source != null && source.length > 0) {
          let top = window.parent.getTop()
          if (!top) { top = window }
          top.download(source[0])
        }
      } else {
        this.reloadIframe('dobleClickAction')
      }
      e.preventDefault()
    },
    pageChanged (page) {
      this.$emit('pageChanged', { 'page': page, 'itemsPerPage': this.itemsPerPage })
    },
    filterOptionsRequested (columnKey) {
      this.$emit('filterOptionsRequested', columnKey)
    },
    filterOptionsSelected (options, columnKey) {
      this.$emit('filterOptionsSelected', options, columnKey)
    },
    selectAll () {
      let items = []
      let self = this
      this.allSelected = !this.allSelected
      this.body.forEach(item => {
        item.IsSelected = self.allSelected
        items.push(item.Id)
      })
      self.$emit('rowShiftChecked', items, self.allSelected)
    },
    check (id) {
      let item = this.body.find(selectedItem => selectedItem.Id === id)
      if (item.IsSelected) {
        this.$emit('rowUnChecked', id)
      } else {
        this.$emit('rowChecked', id)
      }
      item.IsSelected = !item.IsSelected
      this.allSelected = this.body.every(x => x.IsSelected === true)
    },
    shiftCheck (row, currentIndex) {
      let self = this
      let items = []
      if (!row.IsSelected) {
        let previousIndex = this.activeRow.index
        if (!previousIndex) {
          previousIndex = 0
        }
        let rows = Object.keys(this.$refs)
        rows.forEach(row => {
          let rowData = row.split('-')
          let type = rowData[0]
          let id = parseInt(rowData[1])
          let index = rowData[2]
          if (type === 'tr' && index >= (previousIndex < currentIndex ? previousIndex : currentIndex) &&
              index <= (previousIndex > currentIndex ? previousIndex : currentIndex)) {
            let item = this.body.find(selectedItem => selectedItem.Id === id)
            if (item !== undefined) {
              item.IsSelected = true
              items.push(id)
            }
          }
        })
        if (items.length > 0) { self.$emit('rowShiftChecked', items, true) }
        self.allSelected = self.body.every(x => x.IsSelected === true)
      }
    },
    showContextMenu (e, row, index) {
      e.preventDefault()
      if (row.IsActive !== true) {
        this.rowClick(row, index)
      }
      if (window.parent && window.parent.ContextMenuDocument) {
        window.parent.ContextMenuDocument.ShowContextMenu(e.x + Number(window.top.document.getElementById('navbarLeft').clientWidth) + 10, e.y + 85)
      }
    },
    showTableSort () {
      let self = this
      self.sortTable = true
    },
    hideTableSort () {
      let self = this
      self.sortTable = false
    },
    closeContextMenu: function () {
      if (window.parent && window.parent.ContextMenuDocument) {
        window.parent.ContextMenuDocument.Hide()
      }
    },
    dragover (event) {
      event.preventDefault()
      if (!event.currentTarget.classList.contains('dropzone-hover')) {
        event.currentTarget.classList.add('dropzone-hover')
      }
    },
    dragleave (event) {
      if (event.clientY > event.currentTarget.clientHeight || event.clientX <= -1) {
        event.currentTarget.classList.remove('dropzone-hover')
      }
    },
    drop (event) {
      event.preventDefault()
      this.$refs.file.files = event.dataTransfer.files
      this.filesDroped()
      // Clean up
      event.currentTarget.classList.remove('dropzone-hover')
    },
    filesDroped () {
      this.dropedFilesList = [...this.$refs.file.files]
      this.reloadIframe('registerFiles', this.dropedFilesList)
    }
  }
}
</script>

<style lang="scss" scoped>
.text_cell {
  width: 100%;
  left: 0;
  top: 50%;
  line-height: 14px;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
  text-overflow: ellipsis;
  padding-right: 5px;
}

#checkbox_header_cell{
  width: 30px;
  max-width: 30px;
  min-width: 30px;
  padding-left: 4px;
}

#checkbox_cell {
  width: 30px;
  padding-left: 4px;
}

.table_row {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

.dropzone-hover {
  border: 2px dashed #54697d
}

.bt-1 {
  border-top: 1px solid #DDD;
}

.bb-1 {
  border-bottom: 1px solid #DDD;
}

.control-disabled {
  cursor: not-allowed !important;
}
</style>



// WEBPACK FOOTER //
// src/components/grid/documentGridTable.vue